<template>
    <div class="partnership">
		<Loader v-if="loading"/>
		<template v-else>
			<div class="partnership__layout" v-show="activeTab === 'partnership'">
				<div class="partnership__main">
					<div class="partnership__tabs">
						<button class="btn btn--sm partnership__tab active">
							Партнёрские
						</button>
						<button class="btn btn--sm partnership__tab" @click="activeTab = 'personal'">
							Персональные
						</button>
					</div>
					<div class="partnership__fields fields">
						<div class="field-input fields__item">
							<div class="field-input__label">Канал распространения реферальных кодов</div>
							<input name="source" type="text" class="field-input__input" v-model="partnership.source" placeholder="https://ваша-ссылка.тут/" required>
						</div>
						<div class="field-input fields__item">
							<div class="field-input__label">Укажите ваш Telegram</div>
							<input name="contacts" type="text" class="field-input__input" v-model="partnership.contacts" placeholder="username" required>
						</div>
						<div class="fields__item">
							<button class="btn btn--block" @click="save()" :disabled="disableButton" type="submit">
								Отправить заявку
							</button>
						</div>
					</div>
				</div>
				<div class="partnership__content">
					<div class="partnership__title">Мои каналы</div>
					<div class="partnership__items" v-if="partnerships.length">
						<div class="partnership__item" v-for="partnership in partnerships" 	:class="{open: partnership.open}">
							<div class="partnership__item-head">
								<div class="partnership__item-head-row">
									<div class="partnership__item-source">{{ partnership.source }}</div>
									<button class="partnership__item-btn"
										v-if="partnership.is_active"
										@click="partnership.open = !partnership.open"
										type="button"
									>
										Промокоды
										<svg class="partnership__item-btn-icon">
											<use href="#svg-icon-chevron"></use>
										</svg>
									</button>
								</div>
								<div class="partnership__item-head-row" v-if="partnership.new_promo_date">
									<div class="partnership__date-label">Новые промокоды будут доступны:</div>
									<div class="partnership__date-value">{{ partnership.new_promo_date }}</div>
								</div>
							</div>
							<Collapse :open="partnership.open">
								<div class="partnership__table table">
									<table>
										<thead>
										<tr>
											<th>Промокоды <span v-if="isMob">/ Тип</span></th>
											<th v-if="!isMob">Промокоды / Тип</th>
											<th>Активировано</th>
											<th>Сумма</th>
										</tr>
										</thead>
										<tbody>
										<tr v-for="promocode in partnership.promocodes" :class="{ 'inactive': partnership.is_active}">
											<td>
												<div>{{promocode.name}}</div>
												<div  v-if="isMob">{{promocode.type_title}}</div>
											</td>
											<td v-if="!isMob">
												<div>{{promocode.type_title}}</div>
											</td>
											<td>
												{{promocode.activations_count}}/{{promocode.activation}}
											</td>
											<td>
												{{promocode.amount_title}}
											</td>
										</tr>
										</tbody>
									</table>
								</div>
							</Collapse>
						</div>
					</div>
					<div class="empty-message" v-else>
						Вы ещё не создали ни одной заявки на промокоды
					</div>
				</div>
			</div>
			<div class="partnership__layout" v-show="activeTab === 'personal'">
				<div class="partnership__main">
					<div class="partnership__tabs">
						<button class="btn btn--sm partnership__tab" @click="activeTab = 'partnership'">
							Партнёрские
						</button>
						<button class="btn btn--sm partnership__tab active">
							Персональные
						</button>
					</div>
					<div class="partnership__fields fields">
						<div class="field-input fields__item">
							<div class="field-input__label">Начислится на баланс при активации</div>
							<input name="source" type="text" class="field-input__input" v-model="promocode.amount" placeholder="Сумма промокода" required>
						</div>
						<div class="field-input fields__item">
							<div class="field-input__label">Лимит использования промокода</div>
							<input name="contacts" type="text" class="field-input__input" v-model="promocode.activation" placeholder="Количество активаций" required>
						</div>
						<div class="fields__item">
							<button class="btn btn--block" @click="savePromocode()" :disabled="disableButton" type="submit">
								Создать промокод
							</button>
						</div>
					</div>
				</div>
				<div class="partnership__content">
					<div class="partnership__title">Мои промокоды</div>
					<div class="partnership__items" v-if="promocodes.length">
						<div class="partnership__table partnership__table--short table">
							<table>
								<thead>
								<tr>
									<th>Промокод</th>
									<th>Сумма</th>
									<th>Активаций</th>
								</tr>
								</thead>
								<tbody>
								<tr v-for="promocode in promocodes">
									<td><CopyField :text="promocode.name"/></td>
									<td>{{ $root.currency(promocode.amount) }}</td>
									<td>{{ promocode.activations_count }}/{{ promocode.activation }}</td>
								</tr>
								</tbody>
							</table>
						</div>
					</div>
					<div class="empty-message" v-else>
						Вы ещё не создали ни одного персонального промокода
					</div>
				</div>
			</div>
		</template>
    </div>
</template>

<script>

    	import Loader from "../../components/blocks/Loader.vue";
		import breakpointsMixin from "../../mixins/breakpoints-mixin.vue";
		import Collapse from "../../components/blocks/Collapse.vue";
		import CopyField from "../../components/blocks/CopyField.vue";

		export default {
				components: {
					Collapse,
					Loader,
					CopyField
				},

				mixins: [
					breakpointsMixin
				],

        data() {
            return {
                domain: window.location.origin,
                partnerships: [],
                partnership: {},
                promocode: {},
                promocodes: [],
                disableButton: false,
                activeTab: 'partnership',
								loading: false
            }
        },
        mounted() {
            this.loading = true;

            if (!this.$cookie.get('token')) {
                this.loading = false;

                this.$toast.error('Требуется авторизация');

                return this.$router.go(-1);

            }

            this.get();
        },
        methods: {
            get() {
                this.$root.axios.get('/api/partnerships')
                .then(res => {
                    this.partnerships = res.data.partnerships;
                    this.promocodes = res.data.promocodes;
										this.loading = false;
                });
            },
            save() {
                if (!this.partnership.source) {
                    return this.$toast.error('Укажите ваш источник');
                }

                if (!this.partnership.contacts) {
                    return this.$toast.error('Укажите контактные данные');
                }

                this.disableButton = true;
                this.$root.axios.post('/api/partnerships', this.partnership)
                .then(res => {
                    this.disableButton = false;
                    this.partnership = {};

                    this.$toast.success(res.data.message);

                    this.get();
                }).catch(error => {
                    this.disableButton = false;

                    this.$toast.error(this.$root.graphql.axiosGetError(error));
                });
            },
            savePromocode() {
                if (!this.promocode.amount) {
                    return this.$toast.error('Укажите сумму промокода');
                }

                if (!this.promocode.activation) {
                    return this.$toast.error('Укажите количество активаций');
                }

                this.disableButton = true;
                this.$root.axios.post('/api/partnerships/promocode', this.promocode)
                .then(res => {
                    this.disableButton = false;
                    this.promocode = {};
                    this.$root.user.balance = res.data.balance;

                    this.$toast.success(res.data.message);

                    this.get();
                }).catch(error => {
                    this.disableButton = false;

                    this.$toast.error(this.$root.graphql.axiosGetError(error));
                });
            },
            // activate(id) {
            //     this.$root.axios.post('/api/partnerships/' + id + '/activate')
            //     .then(res => {
            //         this.$toast.success(res.data.message);

            //         this.get();
            //     }).catch(error => {
            //         this.$toast.error(this.$root.graphql.axiosGetError(error));
            //     });
            // },
            // recalibrate(id) {
            //     this.$root.axios.post('/api/partnerships/' + id + '/recalibrate')
            //     .then(res => {
            //         this.$toast.success(res.data.message);

            //         this.get();
            //     }).catch(error => {
            //         this.$toast.error(this.$root.graphql.axiosGetError(error));
            //     });
            // },
        }
    }
</script>
